<template>
    <main class="page__content">
        <div class="plain-content">
            <div class="plain-content__inner">
                <div class="plain-content__header">
                    <h1>Impressum</h1>
                </div>
                <div class="plain-content__body">
                    <h2 class="h3">Angaben gemäß § 5 TMG:</h2>
                    <p>Stadtwerke Velbert GmbH
                        <br>Kettwiger Str. 2
                        <br>42549 Velbert
                    </p>
                    <p>
                        <strong>Vertreten durch:</strong>
                        Tobias Grau und Saša Vasković (Geschäftsführer)
                    </p>
                    <p>
                        <strong>
                            <em>Kontakt:</em>
                        </strong>
                    </p>
                    <p>Telefon: 02051/988-0
                        <br>Telefax: 02051/988-439
                        <br>E-Mail: info@stwvelbert.de
                    </p>
                    <p>
                        <strong>
                            <em>Registereintrag:</em>
                        </strong>
                    </p>
                    <p>Eintragung im Handelsregister.
                        <br>Registergericht: Wuppertal
                        <br>Registernummer: HRB 17801
                    </p>
                    <p>
                        <strong>
                            <em>Umsatzsteuer-ID:</em>
                        </strong>
                    </p>
                    <p>
                        Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz: DE 81120
                        90 54
                    </p>
                    <p>
                        <strong>
                            <em>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</em>
                        </strong>
                    </p>
                    <p>Stadtwerke Velbert GmbH
                        <br>Geschäftsführung
                        <br>Kettwiger Str. 2
                        <br>D-42549 Velbert
                    </p>
                    <h3>Haftungsausschluss (Disclaimer)</h3>
                    <p>
                        Haftung für Inhalte: Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für
                        eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                        verantwortlich. Nach § 8 bis 10 TMG sind wir als Diensteanbieter jedoch
                        nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
                        überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
                        Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
                        Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon
                        unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
                        Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von
                        entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
                        entfernen.
                    </p>
                    <p>
                        <strong>
                            <em>Haftung für Links</em>
                        </strong>
                    </p>
                    <p>
                        Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren
                        Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
                        Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten
                        ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                        Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche
                        Rechtsverstöße überprüft. Rechtwidrige Inhalte waren zum Zeitpunkt der
                        Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der
                        verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer
                        Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen
                        werden wir derartige Links umgehend entfernen.
                    </p>
                    <p>
                        <strong>
                            <em>Urheberrecht</em>
                        </strong>
                    </p>
                    <p>
                        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
                        Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
                        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen
                        des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen
                        Autors bzw. Erstellers. Downloads und Kopien dieser Seiten sind nur für den
                        privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf
                        dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte
                        Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
                        gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung
                        aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
                        Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend
                        entfernen.
                        <br>
                        <br>Von Nutzern eingestellte Inhalte (Projektbilder und -Texte, Logos):
                        <br>Die Nutzer haben den Stadtwerken Velbert gegenüber bestätigt, dass die
                        eingestellten Inhalte frei von Rechten Dritter sind. Bei eventuellen
                        Verstößen gegen das Urheberrecht ist der jeweilige Nutzer verantwortlich.
                    </p>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: 'PageTermsOfParticipation'
}
</script>



// WEBPACK FOOTER //
// src/components/PageImprint.vue